// extracted by mini-css-extract-plugin
module.exports = {"root":"Feedback_root__2QpLZ","App":"Feedback_App__2YWFu","User":"Feedback_User__3688u","Inbox":"Feedback_Inbox__3CY_E","Feedback":"Feedback_Feedback__2xQw8"};